import { decodeJwtClaims } from "../../../auth/jwt";

const WRITE_SCOPES = new Set(["calendars.readwrite", "calendars.readwrite.shared"]);

/**
 * Whether the Graph token lets AiVA change the calendar. A token whose scopes
 * can't be read is given the benefit of the doubt: the first change then
 * either works or comes back 403, which the Undo engine reports.
 */
export function canWriteCalendar(token: string | null): boolean {
  if (!token) return false;
  const scp = decodeJwtClaims(token).scp;
  if (typeof scp !== "string") return true;
  return scp.split(" ").some((s) => WRITE_SCOPES.has(s.toLowerCase()));
}
